import React from 'react';

import _ from 'lodash';
import { Clear } from '@mui/icons-material';
import { Grid, IconButton, Stack } from '@mui/material';

import {
  LogViewerTableColumnDefinition,
  LogViewerTableColumnType,
  LogViewerTableNetworkBodyWithJqColumnDefinition,
} from './LogViewerTableColumn';

interface Props {
  additionalColumnDefinitions: LogViewerTableColumnDefinition[];
}

export class LogViewerTableHeader extends React.Component<Props> {
  render() {
    return (
      <div className="logViewerTableHeader">
        <Grid
          container
          spacing={1}
          className="gridContainer"
          alignItems="center"
          columns={this.props.additionalColumnDefinitions.length + 1}
        >
          <Grid item xs={1} />

          {this.props.additionalColumnDefinitions.map((def, index) => {
            return (
              <Grid item key={index} xs={1}>
                <ColumnHeader def={def} />
              </Grid>
            );
          })}
        </Grid>
        <div className="line" />
      </div>
    );
  }
}

class ColumnHeader extends React.Component<{ def: LogViewerTableColumnDefinition }> {
  render() {
    switch (this.props.def.type) {
      case LogViewerTableColumnType.NetworkBodyWithJq:
        const colDef = this.props.def as LogViewerTableNetworkBodyWithJqColumnDefinition;
        return (
          <div>
            <Stack direction="row" alignItems="center" spacing="16px">
              <span>Network body with jq</span>

              <input
                className="jq-body-input"
                type="text"
                defaultValue={colDef.jqQuery}
                placeholder="Enter jq query..."
                onChange={_.debounce((e) => {
                  this.onJqQueryChange(e.target.value);
                }, 300)}
              />

              <IconButton
                onClick={() => {
                  this.deleteColumn();
                }}
                size="small"
              >
                <Clear />
              </IconButton>
            </Stack>
          </div>
        );
    }
  }

  private deleteColumn() {
    if (this.props.def.onDeleteRequest) {
      this.props.def.onDeleteRequest();
    }
  }

  private onJqQueryChange(v: string) {
    const colDef = this.props.def as LogViewerTableNetworkBodyWithJqColumnDefinition;
    colDef.jqQuery = v;
  }
}
